import { filter, startsWith, toLower } from "lodash"
import useResource from "hooks/resources"

interface ForecastMeta {
  id: string
  name: string
  description?: string
}

export const FORECAST_LIST_QUERY = {
  resource: "forecasts",
  url: () => {
    return {
      id: "forecasts",
      query: `query {
        forecasts {
          id
          name
          description
        }
      }`,
    }
  },
}

export function useForecasts() {
  return useResource<ForecastMeta[]>(FORECAST_LIST_QUERY, "forecasts")
}

// This selector is used to prevent editing the name of a portfolio linked to an Alpha Theory forecast
// TODO: Replace this with relatedResource logic when implemented
export function filterATForecasts(forecasts: ForecastMeta[] | null) {
  return filter(forecasts, ({ name }) => startsWith(toLower(name), "at pwr"))
}
